import { Tabs, Space } from "antd";
import { useState } from "react";
import { useStore } from "../../config/store";
import { Info } from "./Clean/Info";
import { Chat } from "./Clean/Chat";

export const CleanBlock = () => {
  const [activeTab, setActiveTab] = useState("info");
  const { clean } = useStore();
  if (!clean) return null;

  return <Space direction="vertical" style={{ width: "100%", gap: 16, height: "100%" }} className={activeTab}>
    <Tabs
      defaultActiveKey="1"
      activeKey={activeTab}
      onChange={setActiveTab}
      items={[
        {
          label: "Уборка",
          key: "info",
          children: <Info />
        },
        {
          label: `Переписка`,
          key: "chat",
          children: <Chat/>
        }
      ]}
    />
  </Space>
};
